import { BrickContext, Brick, registerBrick, Color } from 'olympe';
import { getMuiTheme } from './helpers';

export default class GetThemeColor extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} color
     * @param {string} type
     * @param {number} transparency
     * @param {function(Color)} setColor
     * @param {function(string)} setColorHex
     * @param {function(string)} setColorRGB
     */
    update($, [color, type, transparency], [setColor, setColorHex, setColorRGB]) {
        const sub = $.getParent().observe('$__THEME__', false, true).subscribe((theme) => {

            if (theme) {
                const muiTheme = getMuiTheme(theme);
                const colorFromTheme = muiTheme.palette[color][type];
                let olympeColor;
                if(colorFromTheme.startsWith('rgb')) {
                    const result = colorFromTheme.substring(4, colorFromTheme.length-1).split(',')
                    olympeColor = Color.create(Number(result[0]), Number(result[1]), Number(result[2]), transparency);

                } else {
                    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(colorFromTheme);
                    olympeColor = Color.create(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), transparency);
                }
                setColor(olympeColor);
                setColorHex(olympeColor.toHexString());
                setColorRGB(olympeColor.toRGBString());
            }
        });
        $.onClear(() => sub.unsubscribe());
    }
}

registerBrick('019271e096e376e21599', GetThemeColor);
